
import { computed, defineComponent, ref, watch } from '@nuxtjs/composition-api'
import InputText from '@/components/new-design/form/basic/input-text/InputText.vue'
import SelectList from '@/components/new-design/form/basic/list/SelectList.vue'
export default defineComponent({
  components: { SelectList, InputText },
  props: {
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    info: {
      type: String,
      default: '',
    },
    keyName: {
      type: String,
      default: 'id',
    },
    pending: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const searchText = ref(null)
    const isDropdownShown = computed(() => props.error || props.options.length)
    const accept = (value) => {
      emit('select', value)
    }
    watch(searchText, () => {
      emit('input', searchText.value)
    })
    return {
      accept,
      isDropdownShown,
      searchText,
    }
  },
})
